import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import CountriesIndex from "@/pages/CountriesIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/countries/")({
  head: () => ({
    meta: [
      { title: "Football Predictions by Country | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["leagues", "footballPredictions"] }).meta },
      { name: "description", content: "AI football predictions across every major football nation. Find your country's top divisions — with upcoming picks in one place." },
      { property: "og:title", content: "Football Predictions by Country | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "AI football predictions across every major football nation. Find your country's top divisions — with upcoming picks in one place." },
      { name: "twitter:title", content: "Football Predictions by Country | Statlign" },
      { name: "twitter:description", content: "AI football predictions across every major football nation. Find your country's top divisions — with upcoming picks in one place." },
    ],
  }),
  component: () => (
    <MainLayout>
      <CountriesIndex />
    </MainLayout>
  ),
});
